<section id="content">

  <div class="page page-profile">

    <div class="pageheader">

      <h2>Settings</h2>

      <div class="page-bar">

        <ul class="page-breadcrumb">
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.DASHBOARD"><i class="fa fa-home"></i>
              {{AppSettings.SITE_TITLE | titlecase}}</a>
          </li>
          <li>
            <a [routerLink]="'/'+AppFrontRoutes.SETTINGS">Settings</a>
          </li>
        </ul>

      </div>

    </div>

    <!-- page content -->
    <div class="pagecontent">


      <!-- row -->
      <div class="row">

        <div class="col-md-12">

          <div class="tile tile-simple">

            <!-- tile body -->
            <div class="tile-body p-0">

              <div role="tabpanel">

                <!-- Nav tabs -->
                <ul class="nav nav-tabs tabs-dark" role="tablist">
                  <li role="presentation" [ngClass]="{'active': tabActive === 'tab1'}"><a href="#formTab" aria-controls="feedTab" role="tab"
                      data-toggle="tab">Form Management</a></li>
                  <li role="presentation" [ngClass]="{'active': tabActive === 'tab2'}"><a href="#settingsTab" aria-controls="settingsTab" role="tab"
                      data-toggle="tab">Settings</a></li>
                </ul>

                <!-- Tab panes -->
                <div class="tab-content">

                  <div role="tabpanel" class="tab-pane" [ngClass]="{'active': tabActive === 'tab1'}" id="formTab">

                    <app-sub-form></app-sub-form>


                  </div>

                  <div role="tabpanel" class="tab-pane" [ngClass]="{'active': tabActive === 'tab2'}" id="settingsTab">
                    
                    <app-sub-settings></app-sub-settings>

                  </div>

                </div>

              </div>
            </div>
          </div>

        </div>


      </div>
    </div>
  </div>
</section>